import { createSlice } from "@reduxjs/toolkit";

// ---- import from local actions ----
import { fetchFloorSelection, fetchFloorList } from "./../actions/FloorActions";


const FloorSlice = createSlice({
    name: "floor",
    initialState: {
        floorSelection: {
            data: [],
            status: 'idle',
            error: "",
            loading: false,          
        },
        floorList: {
          data: [],
          status: 'idle',
          error: "",
          loading: false,
      },
    },
    
    extraReducers: (builder) => {
      builder
        .addCase(fetchFloorSelection.pending, (state) => {
          state.floorSelection.status = 'loading';
        })
        .addCase(fetchFloorSelection.fulfilled, (state, action) => {
            state.floorSelection.status = 'idle';
            state.floorSelection.data = action.payload.result;
        })
        .addCase(fetchFloorSelection.rejected, (state, action) => {
          state.floorSelection.status = 'rejected';
          state.floorSelection.error = action.error.message;
        })

        .addCase(fetchFloorList.pending, (state) => {
          state.floorList.status = 'loading';
        })
        .addCase(fetchFloorList.fulfilled, (state, action) => {
            state.floorList.status = 'idle';
            state.floorList.data = action.payload.result;
        })
        .addCase(fetchFloorList.rejected, (state, action) => {
          state.floorList.status = 'rejected';
          state.floorList.error = action.error.message;
        })
    },
});


export default FloorSlice.reducer;
